import { t } from "i18next";

// A visit's note options are stored in English ("Bullet Point", "Detailed",
// "Physical"); this is how they read in the interface language. Unknown
// values are shown as stored.
const KEYS = {
  Paragraph: "noteOptions.style.paragraph",
  "Bullet Point": "noteOptions.style.bulletPoint",
  Concise: "noteOptions.format.concise",
  Detailed: "noteOptions.format.detailed",
  Physical: "noteOptions.exam.physical",
  Virtual: "noteOptions.exam.virtual",
} as const;

export const noteOptionLabel = (value: string): string => {
  const key = KEYS[value as keyof typeof KEYS] as
    | (typeof KEYS)[keyof typeof KEYS]
    | undefined;
  return key ? t(key) : value;
};
